import { Icon } from 'common/icon';

import styles from './styles.module.css';

type Props = {
  text: string;
};

export const Banner = ({ text }: Props) => {
  return (
    <div className={styles.banner}>
      <Icon.ExclamationMark />
      <span>{text}</span>
    </div>
  );
};
